import { render } from "./good.vue?vue&type=template&id=c4579e80&scoped=true"
import script from "./good.vue?vue&type=script&lang=js"
export * from "./good.vue?vue&type=script&lang=js"

import "./good.vue?vue&type=style&index=0&id=c4579e80&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4579e80"]])

export default __exports__